import React from 'react'
import {
  Constants,
  Label,
  useContainerDimensionsContext,
} from '@therms/atalaya'
import './RecordFields.css'
import { RecordField } from './RecordField'
import { RPCDocs } from '@therms/react-modules'
import classNames from 'classnames'

interface VehicleRecordFieldsProps {
  record: RPCDocs.Records.GetRecordProfile.v1.Record
}

function VehicleRecordFields({ record }: VehicleRecordFieldsProps) {
  const {
    viewport: { width: mainWidth },
  } = useContainerDimensionsContext()

  let layout = 'Xxl'
  if (mainWidth < Constants.Breakpoint.Sm.width) {
    layout = 'Sm'
  } else if (mainWidth < Constants.Breakpoint.Xl.width) {
    layout = 'Xl'
  }

  return (
    <div className="grid grid-cols-6 gap-y-lg">
      <div
        className={classNames({
          'col-span-6': layout === 'Sm',
        })}
      >
        <Label className="label">Year</Label>
        <RecordField fieldType="number" value={record.fields.year} />
      </div>

      <div
        className={classNames({
          'col-span-2': layout === 'Xxl' || layout === 'Xl',
          'col-span-6': layout === 'Sm',
        })}
      >
        <Label className="label">Color</Label>
        <RecordField fieldType="select" value={record.fields.color} />
      </div>

      <div
        className={classNames({
          'col-span-3': layout === 'Xl' || layout === 'Xxl',
          'col-span-6': layout === 'Sm',
        })}
      >
        <Label className="label">Type</Label>
        <RecordField fieldType="select" value={record.fields.type} />
      </div>

      <div
        className={classNames({
          'col-span-3': layout === 'Xxl' || layout === 'Xl',
          'col-span-6': layout === 'Sm',
        })}
      >
        <Label className="label">Make</Label>
        <RecordField value={record.fields.make} />
      </div>

      <div
        className={classNames({
          'col-span-3': layout === 'Xxl' || layout === 'Xl',
          'col-span-6': layout === 'Sm',
        })}
      >
        <Label className="label">Model</Label>
        <RecordField value={record.fields.model} />
      </div>

      <div
        className={classNames({
          'col-span-2': layout === 'Xxl',
          'col-span-6': layout === 'Sm',
        })}
      >
        <Label className="label">Plate</Label>
        <RecordField value={record.fields.plate} />
      </div>

      <div
        className={classNames({
          'col-span-2': layout === 'Xxl' || layout === 'Xl',
          'col-span-6': layout === 'Sm',
        })}
      >
        <Label className="label">State</Label>
        <RecordField value={record.fields.state} />
      </div>

      <div
        className={classNames({
          'col-span-2': layout === 'Xxl',
          'col-span-3': layout === 'Xl',
          'col-span-6': layout === 'Sm',
        })}
      >
        <Label className="label">Vin</Label>
        <RecordField value={record.fields.vin} />
      </div>

      <div className="col-span-6">
        <Label className="label">Additional Info</Label>
        <RecordField fieldType="textarea" value={record.fields.additional} />
      </div>
    </div>
  )
}

export { VehicleRecordFields }
